<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1000"
    v-if="serverData"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Add New Status Process</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <!--begin::Body-->
        <form id="createForm" class="py-3 row">
          <div class="h-75px my-0 col-12 col-sm-6">
            <v-text-field
              dense
              outlined
              v-model="formData.payload_attribute_name"
              label="Payload Attribute Name"
              required
              clearable
              :error-messages="payloadAttributeNameErrors"
              @input="$v.formData.payload_attribute_name.$touch()"
              @blur="$v.formData.payload_attribute_name.$touch()"
            ></v-text-field>
          </div>
          <div class="h-75px my-0 col-12 col-sm-6">
            <v-text-field
              dense
              outlined
              v-model="formData.payload_attribute_value"
              label="Payload Attribute Value"
              required
              clearable
              :error-messages="payloadAttributeValueErrors"
              @input="$v.formData.payload_attribute_value.$touch()"
              @blur="$v.formData.payload_attribute_value.$touch()"
            ></v-text-field>
          </div>
          <div class="h-75px my-0 col-12 col-sm-6">
            <v-select
              dense
              outlined
              v-model="formData.action"
              :items="serverData.actions"
              item-name="text"
              item-value="index"
              label="Action"
              clearable
              :error-messages="actionErrors"
              @input="$v.formData.action.$touch()"
              @blur="$v.formData.action.$touch()"
            ></v-select>
          </div>
          <div class="h-75px my-0 col-12 col-sm-6">
            <v-text-field
              dense
              outlined
              v-model="formData.message"
              label="Message"
              required
              clearable
              :error-messages="meassageErrors"
              @input="$v.formData.message.$touch()"
              @blur="$v.formData.message.$touch()"
            ></v-text-field>
          </div>

          <!--end::Body-->
        </form>

        <!--begin::Actions-->
        <div class="my-4 d-flex flex-grow-1 align-end justify-center mt-10">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetCreateForm"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitCreateForm"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import { addItemMessage } from "@/core/constants/globalVariables";
import ApiService from "@/core/services/api.service";

export default {
  mixins: [validationMixin],
  validations: {
    formData: {
      payload_attribute_name: { required },
      payload_attribute_value: { required },
      action: { required },
      message: { required },
    },
  },
  name: "AddItem",
  props: ["refresher", "pageLoader"],
  data: () => ({
    dialog: false,
    serverData: null,
    formData: {
      payload_attribute_name: null,
      payload_attribute_value: null,
      action: null,
      message: null,
    },
  }),
  methods: {
    handleFormValidation(fieldName) {
      const errors = [];
      if (!this.$v.formData[fieldName].$dirty) return errors;
      if ("email" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].email &&
          errors.push("This email address is invalid");
      }
      if ("required" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].required &&
          errors.push("This field is required");
      }
      return errors;
    },
    loadDataFromServer() {
      this.pageLoader(true);
      ApiService.post(
        "/validations/datahub/platform_status_processing_actions/create",
        {
          integration_id: this.$store.getters.getINTEGRATIONS2IntegrationId,
        }
      )
        .then((response) => {
          this.serverData = response.data;

          this.pageLoader(false);
        })
        .catch(() => {
          this.dialog = false;
          this.pageLoader(false);
        });
    },
    toggleModal() {
      if (this.dialog) {
        this.resetCreateForm();
        this.serverData = null;
      } else this.loadDataFromServer();
      this.dialog = !this.dialog;
    },

    submitCreateForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.pageLoader(true);
        let data = this.formData;
        data.integration_id = this.$store.getters.getINTEGRATIONS2IntegrationId;
        ApiService.post(
          "/validations/datahub/platform_status_processing_actions/store",
          data
        )
          .then(() => {
            Swal.fire({
              title: "Created",
              text: `${addItemMessage}`,
              icon: "success",
              showConfirmButton: false,
              timer: 2500,
            });
            this.toggleModal();
            this.refresher();
          })
          .catch(() => {
            this.pageLoader(false);
          });
      }
    },
    resetCreateForm() {
      this.$v.$reset();
      this.formData = {
        integration_id: null,
        shipping_type_id: null,
        store_code: null,
      };
    },
  },
  computed: {
    payloadAttributeNameErrors() {
      return this.handleFormValidation("payload_attribute_name");
    },
    payloadAttributeValueErrors() {
      return this.handleFormValidation("payload_attribute_value");
    },
    actionErrors() {
      return this.handleFormValidation("action");
    },
    meassageErrors() {
      return this.handleFormValidation("message");
    },
    shipping_type_idErrors() {
      return this.handleFormValidation("shipping_type_id");
    },
    store_codeErrors() {
      return this.handleFormValidation("store_code");
    },
  },
};
</script>
